// import { useState } from "react";
// import Loader from "./app/elements/loader";
// import RootLayout from "./layouts/root-layout";
// import ScrollToTop from "./app/elements/ScrollToTop";
// import ChatBot from "./app/components/chatbot/chatbot";

// export default function App() {
//   const [isLoading, setIsLoading] = useState(true);

//   setTimeout(() => {
//     setIsLoading(false);
//   }, 500);

//   return (
//     <>
//       {
//         isLoading && <Loader />
//       }
//       <ScrollToTop />
//       <RootLayout />


//       <ChatBot />
     
//     </>
//   );
// }



import { useEffect, useState } from "react";
import Loader from "./app/elements/loader";
import RootLayout from "./layouts/root-layout";
import ScrollToTop from "./app/elements/ScrollToTop";
import ChatBot from "./app/components/chatbot/chatbot";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const GA_MEASUREMENT_ID = "G-84T2Q7L1R5";

    // Create GA script
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Inline initialization after script loads
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}', { page_path: window.location.pathname });
    `;
    document.head.appendChild(inlineScript);
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <ScrollToTop />
      <RootLayout />
      <ChatBot />
    </>
  );
}
